module.exports = __webpack_public_path__ + "img/cover7.39608e1b.png";